"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetInstanceField = void 0;
const react_1 = __importStar(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const react_query_1 = require("react-query");
const json_form_context_1 = require("../../json-form-context");
const ramda_1 = require("ramda");
const styled_1 = require("./styled");
const json_form_1 = require("../../json-form");
const hooks_1 = require("./hooks");
const components_1 = require("../../components");
const nullFunction = () => null;
const WidgetInstanceField = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const devFederation = DEV_FEDERATION;
    const { formData = { widgetId: undefined, props: {}, cleared: false }, onChange, uiSchema, value, propsForSettingsAreHidden } = props;
    const { widgetSchemes, RemoteForm, checkIsDevVersion } = (0, react_1.useContext)(json_form_context_1.JsonFormContext);
    // formData.props.widgetId fow backward compatibility
    const cleared = Boolean(formData.cleared);
    const widgetId = (_a = formData.widgetId) !== null && _a !== void 0 ? _a : (_b = formData.props) === null || _b === void 0 ? void 0 : _b.widgetId;
    const widgets = (0, hooks_1.useSupportedWidgets)(widgetSchemes, uiSchema);
    const allowClear = ((_c = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:allowClear']) !== null && _c !== void 0 ? _c : false) && !(widgets.length === 1 && props.required);
    const needPreset = (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:needPresets']) || false;
    const httpClient = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:httpClient'];
    const apiUrl = (_d = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:apiUrl']) !== null && _d !== void 0 ? _d : '';
    const currentWidget = (0, react_1.useMemo)(() => widgetSchemes.find(({ id }) => id.toString() === (widgetId === null || widgetId === void 0 ? void 0 : widgetId.toString())), [widgetId, widgetSchemes]);
    const currentWidgetSchema = (0, hooks_1.usePropertiesFilter)(currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.schema, uiSchema);
    const options = (0, react_1.useMemo)(() => widgets.map(({ name, id }) => ({ value: id, label: name })), [widgets]);
    const [selectedWidgetId, selectWidget] = (0, react_1.useState)(currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.id);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const clear = () => {
        setShowTooltip(false);
        onChange({ cleared: true });
        setIsOpen(false);
        selectWidget(undefined);
    };
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const tooltipAnchorRef = (0, react_1.useRef)(null);
    const handleChangeWidget = (0, react_1.useCallback)(({ value }) => {
        var _a;
        onChange({
            widgetId: value,
            id: crypto.randomUUID(),
            props: { title: (_a = formData.props) === null || _a === void 0 ? void 0 : _a.title }
        });
        setIsOpen(true);
        selectWidget(value);
    }, [(_e = formData.props) === null || _e === void 0 ? void 0 : _e.title, onChange]);
    const handleChangePreset = (selectedPreset) => {
        handleChangeProps(selectedPreset.props);
    };
    (0, react_1.useEffect)(() => {
        if (props.required && !currentWidget && widgets.length === 1) {
            setTimeout(() => handleChangeWidget({ value: widgets[0].id }), 0);
        }
    }, [props.required, widgets, currentWidget, handleChangeWidget]);
    (0, hooks_1.useDefaultWidgetSelect)({ widgets, currentWidget, handleChangeWidget, uiSchema, cleared });
    const handleChangeProps = (data) => {
        onChange(Object.assign(Object.assign({}, formData), { widgetId, props: data }));
    };
    const queryKey = (0, react_1.useMemo)(() => [`widget-presets-${widgetId}`], []);
    const { data = [] } = (0, react_query_1.useQuery)({
        queryKey,
        queryFn() {
            return httpClient(`${apiUrl}/preset/${widgetId}`, {
                traceId: 'af53d5c1-b25f-496c-b14e-e4be60b86691'
            });
        },
        enabled: Boolean(needPreset) && Boolean(widgetId) && Boolean(httpClient),
        select: (data) => {
            return (data.map((item) => {
                var _a, _b, _c;
                return ({
                    label: (_b = (_a = item === null || item === void 0 ? void 0 : item.preset) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.title,
                    value: item === null || item === void 0 ? void 0 : item.id,
                    props: (_c = item === null || item === void 0 ? void 0 : item.preset) === null || _c === void 0 ? void 0 : _c.props
                });
            }) || []);
        }
    });
    const isEmptyScheme = (0, react_1.useMemo)(() => {
        var _a, _b;
        return ((_a = currentWidgetSchema === null || currentWidgetSchema === void 0 ? void 0 : currentWidgetSchema.jsonSchema) === null || _a === void 0 ? void 0 : _a.type) === 'object' &&
            (!((_b = currentWidgetSchema === null || currentWidgetSchema === void 0 ? void 0 : currentWidgetSchema.jsonSchema) === null || _b === void 0 ? void 0 : _b.properties) ||
                (0, ramda_1.isEmpty)(currentWidgetSchema.jsonSchema.properties));
    }, [currentWidgetSchema === null || currentWidgetSchema === void 0 ? void 0 : currentWidgetSchema.jsonSchema]);
    // todo: check the version: version === 'dev-version'
    const isLocalDevMode = (0, react_1.useMemo)(() => {
        var _a, _b;
        return (devFederation.includes((_a = currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.id) !== null && _a !== void 0 ? _a : '') ||
            devFederation.includes((_b = currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.name) !== null && _b !== void 0 ? _b : ''));
    }, [currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.id, currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.name]);
    if ((0, ramda_1.isNil)(selectedWidgetId) && !options.length) {
        return null;
    }
    if (props.required && isEmptyScheme && !(0, ramda_1.isNil)(selectedWidgetId) && options.length === 1) {
        return null;
    }
    const isRemoteModule = (0, ramda_1.isEmpty)(currentWidgetSchema === null || currentWidgetSchema === void 0 ? void 0 : currentWidgetSchema.jsonSchema) ||
        isLocalDevMode ||
        checkIsDevVersion(currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.id) ||
        (currentWidgetSchema === null || currentWidgetSchema === void 0 ? void 0 : currentWidgetSchema.formType) === 'customized' ||
        (currentWidgetSchema === null || currentWidgetSchema === void 0 ? void 0 : currentWidgetSchema.formType) === 'dedicated';
    const title = react_1.default.createElement(wl_ui_kit_1.Body2, null, ((_f = formData.props) === null || _f === void 0 ? void 0 : _f.title) || ((_g = props.schema) === null || _g === void 0 ? void 0 : _g.title) || 'Widget Instance');
    const clearBtn = (react_1.default.createElement(wl_ui_kit_1.IconButton, { ref: tooltipAnchorRef, onClick: () => setShowTooltip(true) },
        react_1.default.createElement(wl_ui_kit_1.Icon, { name: "remove", size: "small" })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.StyledTooltip, { key: String(showTooltip), anchorEl: tooltipAnchorRef.current, isOpen: showTooltip, onClickOutside: () => setShowTooltip(false) },
            react_1.default.createElement(components_1.DeleteTooltip, { onDelete: clear, onClose: () => setShowTooltip(false), deleteText: "Clear" })),
        react_1.default.createElement("div", null,
            (0, ramda_1.isNil)(selectedWidgetId) && (react_1.default.createElement(wl_ui_kit_1.Select, { value: options.find(({ value }) => value === selectedWidgetId), onChange: handleChangeWidget, options: options, placeholder: (_h = props.placeholder) !== null && _h !== void 0 ? _h : 'Select Widget', disabled: !(0, ramda_1.isNil)(selectedWidgetId), label: (_j = props.schema) === null || _j === void 0 ? void 0 : _j.title })),
            !(0, ramda_1.isNil)(currentWidget) && (react_1.default.createElement(styled_1.InstanceWrapper, null,
                isEmptyScheme ? (react_1.default.createElement(styled_1.InstanceHeader, { "$withoutAccordion": true },
                    title,
                    allowClear ? clearBtn : react_1.default.createElement("div", null, " "),
                    react_1.default.createElement(styled_1.WidgetName, null, currentWidget.name))) : (react_1.default.createElement(styled_1.InstanceHeader, null,
                    react_1.default.createElement(styled_1.Accordion, { onClick: () => setIsOpen(!isOpen), "$isOpen": isOpen, height: "20" }),
                    title,
                    allowClear ? clearBtn : react_1.default.createElement("div", null, " "),
                    react_1.default.createElement("div", null, " "),
                    react_1.default.createElement(styled_1.WidgetName, null, currentWidget.name),
                    react_1.default.createElement("div", null, " "))),
                isOpen && currentWidgetSchema && !isEmptyScheme && (react_1.default.createElement("div", null,
                    needPreset && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(styled_1.WrapSelectPreset, null,
                            react_1.default.createElement(wl_ui_kit_1.Select, { value: value, onChange: handleChangePreset, options: data, placeholder: (_k = props.placeholder) !== null && _k !== void 0 ? _k : 'Select Preset', label: (_l = props.schema) === null || _l === void 0 ? void 0 : _l.title })),
                        react_1.default.createElement(wl_ui_kit_1.Heading4, null, "Widget Settings"))),
                    react_1.default.createElement(styled_1.InstanceBlock, null, isRemoteModule ? (react_1.default.createElement(RemoteForm, { formData: formData.props, onSubmit: nullFunction, onChange: handleChangeProps, onChangeValidStatus: nullFunction, widgetId: currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.id, widgetType: currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.name, propsForSettingsAreHidden: propsForSettingsAreHidden })) : (react_1.default.createElement(json_form_1.JsonForm, { tagName: "div", formData: formData.props, schema: currentWidgetSchema, onChange: handleChangeProps, onSubmit: nullFunction, propsForSettingsAreHidden: propsForSettingsAreHidden }))))))))));
};
exports.WidgetInstanceField = WidgetInstanceField;
//# sourceMappingURL=widget-instance-field.js.map